import { IArtistSpotlightTemplate } from '@/types/components/ITemplate'
import { MarkdownContent } from '../../MarkdownContent'

interface ArtistSpotlightProps {
  template: IArtistSpotlightTemplate
}

export const ArtistSpotlight = ({
  template: { content },
}: ArtistSpotlightProps) => {
  return (
    <>
      <div className='relative flex w-full justify-center'>
        <div className='relative mx-6 w-full max-w-[800px] sm:mx-12'>
          <MarkdownContent increasedMargins>{content}</MarkdownContent>
        </div>
      </div>
    </>
  )
}
